import { render, staticRenderFns } from "./IndexRedesignA.vue?vue&type=template&id=4672b9cc"
import script from "./IndexRedesignA.vue?vue&type=script&lang=js"
export * from "./IndexRedesignA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports